import random from 'lodash/random';
import filter from 'lodash/filter';
import map from 'lodash/map';
import extend from 'lodash/extend';
import mixin from 'lodash/mixin';
import _ from 'lodash/wrapperLodash';

mixin(_, {
  random: random,
  filter: filter,
  map: map,
  extend: extend
});

const filterCategory = (array, filter) => {
  const randomKey = () => {
    return 'imgkey_' + _.random(0, 10000) + '-' + _.random(0, 100);
  };
  const filterArray = (array, filter) => {
    return _.filter(array, {
      nav_categories : [
        filter
      ]
    });
  };
  const filtered = filterArray(array, filter);
  const newArray = _.map(filtered, i =>
    _.extend({new_key: randomKey()}, i));
  return newArray;
};

export default filterCategory;



// WEBPACK FOOTER //
// ./src/scripts/filter-category.js